import cloneDeep from 'lodash/fp/cloneDeep'
import { listDifferenceComputer, modificationStates } from '../../../../../common/ReducerHelperFunctions/listDifferenceComputer'
import {
  PENDING_APPROVAL_ADVISER_EDUCATION_ADD_NEW_QUALIFICATION
  , PENDING_APPROVAL_ADVISER_EDUCATION_START_EDITING
  , PENDING_APPROVAL_ADVISER_EDUCATION_STOP_EDITING
  , PENDING_APPROVAL_ADVISER_EDUCATION_CANCEL_EDITING
  , PENDING_APPROVAL_ADVISER_EDUCATION_SET_QUALIFICATION
  , PENDING_APPROVAL_ADVISER_EDUCATION_SET_QUALIFICATION_STUDY_START_MONTH
  , PENDING_APPROVAL_ADVISER_EDUCATION_SET_QUALIFICATION_STUDY_START_YEAR
  , PENDING_APPROVAL_ADVISER_EDUCATION_SET_QUALIFICATION_STUDY_END_MONTH
  , PENDING_APPROVAL_ADVISER_EDUCATION_SET_QUALIFICATION_STUDY_END_YEAR
  , PENDING_APPROVAL_ADVISER_EDUCATION_SET_STUDY_END_DATE_CURRENT
  , PENDING_APPROVAL_ADVISER_EDUCATION_DELETE_QUALIFICATION
  , PENDING_APPROVAL_ADVISER_EDUCATION_DELETE_QUALIFICATION_MODAL
  , PENDING_APPROVAL_ADVISER_EDUCATION_DELETING_QUALIFICATION
  , PENDING_APPROVAL_ADVISER_EDUCATION_DELETED_QUALIFICATION
  , PENDING_APPROVAL_ADVISER_EDUCATION_CANCEL_DELETING_QUALIFICATION
} from './pendingApprovalAdviserProfileEducationEditorActions'

import { events as containerEvents } from '../../AdviserProfileApprovalEditorContainer/adviserProfileApprovalEditorContainerActions'
import { validiateTextField } from '../../../../../common/forms/validationFunctions'

const initialState = {
  loadingEducation: false,
  editingQualification: false,
  editingQualificationIndex: -1,
  deletingQualification: false,
  deletingQualificationModal: false,
  deletingQualificationIndex: -1,
  qualificationsBeforeEditing: [],
  qualificationsModifications: [],
  studyStartYear: null,
  studyStartMonth: null,
  studyEndYear: null,
  studyEndMonth: null,
  isInvalid: {
    formIsValid: true,
    description: {
      valid: true,
      isInvalid: false,
      message: null
    },
    institution: {
      valid: true,
      isInvalid: false,
      message: null
    },
    startYear: {
      valid: true,
      isInvalid: false,
      message: null
    },
    startMonth: {
      valid: true,
      isInvalid: false,
      message: null
    },
    endYear: {
      valid: true,
      isInvalid: false,
      message: null
    },
    endMonth: {
      valid: true,
      isInvalid: false,
      message: null
    }
  }
}

const isFormValid = (state) => {
  return (
    (state.education.isInvalid.description.valid ?? true) &&
    (state.education.isInvalid.institution.valid ?? true) &&
    (state.education.isInvalid.startYear.valid ?? true) &&
    (state.education.isInvalid.startMonth.valid ?? true) &&
    (state.education.isInvalid.endYear.valid ?? true) &&
    (state.education.isInvalid.endMonth.valid ?? true)
  )
}

export default function (state = initialState, action) {
  var newState = copyEducationState(state)
  let date
  switch (action.type) {
    case containerEvents.fetch.fetched:
      newState.education.qualificationsModifications = findEducationDifferences(newState)
      return newState
    case containerEvents.edit.cancel:
      newState.education = cloneDeep(initialState)
      newState.education.qualificationsModifications = findEducationDifferences(newState)
      return newState
    case PENDING_APPROVAL_ADVISER_EDUCATION_ADD_NEW_QUALIFICATION:
       date = new Date(Date.now())
      const newQualification = {
        ...action.qualification,
        studyStartDate: date.toISOString()
      }
      const updatedQualifications = [
        ...newState.education.qualificationsModifications,
        newQualification
      ]
      newState.education = {
        ...newState.education,
        editingQualification: true,
        editingQualificationIndex: updatedQualifications.length - 1,
        qualificationsBeforeEditing: cloneDeep(newState.education.qualificationsModifications),
        qualificationsModifications: updatedQualifications,
        isInvalid: {
          ...newState.education.isInvalid,
          description: { ...newState.education.isInvalid.description, valid: false },
          institution: { ...newState.education.isInvalid.institution, valid: false },
          startYear: { ...newState.education.isInvalid.startYear, valid: true },
          startMonth: { ...newState.education.isInvalid.startMonth, valid: true },
          endYear: { ...newState.education.isInvalid.endYear, valid: true },
          endMonth: { ...newState.education.isInvalid.endMonth, valid: true },
          // A newly added qualification has no description or institution yet, so the form
          // cannot be valid. isFormValid(newState) read the pre-update state and returned true.
          formIsValid: false
        },
        studyStartMonth: 0,
        studyStartYear: date.getFullYear() - 1,
        studyEndMonth: 11,
        studyEndYear: date.getFullYear()
      }
      return newState
    case PENDING_APPROVAL_ADVISER_EDUCATION_START_EDITING:
      newState.education.editingQualification = true
      newState.education.editingQualificationIndex = action.index
      date = new Date(newState.education.qualificationsModifications[newState.education.editingQualificationIndex].studyStartDate)
      newState.education.studyStartMonth = date.getMonth()
      newState.education.studyStartYear = date.getFullYear()
      if (newState.education.qualificationsModifications[newState.education.editingQualificationIndex].studyEndDate !== null) {
        date = new Date(newState.education.qualificationsModifications[newState.education.editingQualificationIndex].studyEndDate)
        newState.education.studyEndMonth = date.getMonth()
        newState.education.studyEndYear = date.getFullYear()
      }
      newState.education.qualificationsBeforeEditing = cloneDeep(newState.education.qualificationsModifications)
      return newState
    case PENDING_APPROVAL_ADVISER_EDUCATION_STOP_EDITING:
      newState.education.editingQualification = false
      newState.education.editingQualificationIndex = initialState.editingQualificationIndex
      newState.education.studyStartMonth = initialState.studyStartMonth
      newState.education.studyStartYear = initialState.studyStartYear
      newState.education.studyEndMonth = initialState.studyEndMonth
      newState.education.studyEndYear = initialState.studyEndYear
      newState.education.isInvalid = cloneDeep(initialState.isInvalid)
      newState.pendingApprovalProfile.qualifications = updateQualifications(newState)
      newState.education.qualificationsBeforeEditing = []
      newState.edited = true
      return newState
    case PENDING_APPROVAL_ADVISER_EDUCATION_CANCEL_EDITING:
      newState.education.editingQualification = false
      newState.education.editingQualificationIndex = initialState.editingQualificationIndex
      newState.education.studyStartMonth = initialState.studyStartMonth
      newState.education.studyStartYear = initialState.studyStartYear
      newState.education.studyEndMonth = initialState.studyEndMonth
      newState.education.studyEndYear = initialState.studyEndYear
      newState.education.isInvalid = cloneDeep(initialState.isInvalid)
      newState.education.qualificationsModifications = cloneDeep(newState.education.qualificationsBeforeEditing)
      newState.education.qualificationsBeforeEditing = []
      return newState
    case PENDING_APPROVAL_ADVISER_EDUCATION_SET_QUALIFICATION:
      newState.education.qualificationsModifications[newState.education.editingQualificationIndex] = cloneDeep(action.qualification)
      newState.education.isInvalid.description = validiateTextField(action.qualification.description, 255, true)
      newState.education.isInvalid.institution = validiateTextField(action.qualification.institution, 255, true)
      date = new Date(newState.education.qualificationsModifications[newState.education.editingQualificationIndex].studyStartDate)
       if (
  newState.education.studyStartMonth !== null &&
  newState.education.studyStartYear !== null &&
  !isNaN(newState.education.studyStartYear)
) {
  date.setMonth(newState.education.studyStartMonth)
  date.setFullYear(newState.education.studyStartYear)

  newState.education.qualificationsModifications[
    newState.education.editingQualificationIndex
  ].studyStartDate = date.toISOString()
}
      if (newState.education.studyEndMonth !== null && newState.education.studyEndYear !== null  &&
  !isNaN(newState.education.studyEndYear)) {
        date = new Date(newState.education.qualificationsModifications[newState.education.editingQualificationIndex].studyEndDate)
        date.setMonth(newState.education.studyEndMonth)
        date.setFullYear(newState.education.studyEndYear)
        newState.education.qualificationsModifications[newState.education.editingQualificationIndex].studyEndDate = date.toISOString()
      }
      
      newState.education.isInvalid.description = action.validationResult.description
      newState.education.isInvalid.institution = action.validationResult.institution
      newState.education.isInvalid.formIsValid = isFormValid(newState)
      return newState
    case PENDING_APPROVAL_ADVISER_EDUCATION_SET_QUALIFICATION_STUDY_START_MONTH:
      newState.education.isInvalid.startMonth = cloneDeep(action.validationResult)
      newState.education.studyStartMonth = action.month
      newState.education.isInvalid.formIsValid = isFormValid(newState)
      return newState
    case PENDING_APPROVAL_ADVISER_EDUCATION_SET_QUALIFICATION_STUDY_START_YEAR:
      

      newState.education.studyStartYear =
    action.year === ''
      ? null
      : parseInt(action.year)

     newState.education.isInvalid.startYear =
    cloneDeep(action.validationResult)

  newState.education.isInvalid.formIsValid =
    isFormValid(newState)

  return newState
    case PENDING_APPROVAL_ADVISER_EDUCATION_SET_QUALIFICATION_STUDY_END_MONTH:
      newState.education.isInvalid.endMonth = cloneDeep(action.validationResult)
      newState.education.studyEndMonth = action.month
      newState.education.isInvalid.formIsValid = isFormValid(newState)
      return newState
    case PENDING_APPROVAL_ADVISER_EDUCATION_SET_QUALIFICATION_STUDY_END_YEAR:
      
      newState.education.studyEndYear =
    action.year === ''
      ? null
      : parseInt(action.year)

  newState.education.isInvalid.endYear =
    cloneDeep(action.validationResult)

  newState.education.isInvalid.formIsValid =
    isFormValid(newState)

  return newState
    case PENDING_APPROVAL_ADVISER_EDUCATION_SET_STUDY_END_DATE_CURRENT:
      if (newState.education.qualificationsModifications[newState.education.editingQualificationIndex].studyEndDate !== null) {
        newState.education.qualificationsModifications[newState.education.editingQualificationIndex].studyEndDate = null
        newState.education.studyEndMonth = null
        newState.education.studyEndYear = null
        newState.education.isInvalid.endYear.valid = true
      } else {
        date = new Date(Date.now())
        newState.education.qualificationsModifications[newState.education.editingQualificationIndex].studyEndDate = date.toISOString()
        newState.education.studyEndYear = date.getFullYear()
        newState.education.studyEndMonth = date.getMonth()
        newState.education.isInvalid.endYear.valid = true
      }
      newState.education.isInvalid.formIsValid = isFormValid(newState)
      return newState
    case PENDING_APPROVAL_ADVISER_EDUCATION_DELETE_QUALIFICATION:
      newState.education.qualificationsModifications[newState.education.deletingQualificationIndex].modificationState = modificationStates.deleted
      newState.education.deletingQualificationIndex = -1
      newState.education.deletingQualificationModal = false
      newState.pendingApprovalProfile.qualifications = updateQualifications(newState)
      newState.edited = true
      return newState
    case PENDING_APPROVAL_ADVISER_EDUCATION_DELETE_QUALIFICATION_MODAL:
      newState.education.deletingQualificationModal = true
      newState.education.deletingQualificationIndex = action.index
      return newState
    case PENDING_APPROVAL_ADVISER_EDUCATION_DELETING_QUALIFICATION:
      newState.education.deletingQualification = true
      return newState
    case PENDING_APPROVAL_ADVISER_EDUCATION_DELETED_QUALIFICATION:
      newState.education.deletingQualification = false
      newState.education.deletingQualificationIndex = initialState.deletingQualificationIndex
      newState.education.deletingQualificationModal = false
      newState.edited = true
      return newState
    case PENDING_APPROVAL_ADVISER_EDUCATION_CANCEL_DELETING_QUALIFICATION:
      newState.education.deletingQualificationIndex = initialState.deletingQualificationIndex
      newState.education.deletingQualificationModal = false
      return newState
  }
  return state
}

function updateQualifications (state) {
  return cloneDeep(state.education.qualificationsModifications.filter((qualification) => qualification.modificationState !== modificationStates.deleted))
}

function copyEducationState (state) {
  var newState = cloneDeep(state)
  newState.pendingApprovalProfile = cloneDeep(state.pendingApprovalProfile)
  if (state.pendingApprovalProfile) {
    newState.pendingApprovalProfile.educationPreferences = cloneDeep(state.pendingApprovalProfile.educationPreferences)
  }
  return newState
}

function educationModified (oldItem, newItem, modifiedState, unModifiedState) {
  if (oldItem.description !== newItem.description ||
    oldItem.institution !== newItem.institution ||
    oldItem.studyStartDate !== newItem.studyStartDate ||
    oldItem.studyEndDate !== newItem.studyEndDate) {
    return modifiedState
  }

  return unModifiedState
}

function findEducationDifferences (state) {
  var modifications
  if (state.publishedProfile) {
    var oldList = state.publishedProfile.qualifications
    var newList = state.pendingApprovalProfile.qualifications
    modifications = listDifferenceComputer(oldList, newList, ['description', 'institution', 'studyStartDate', 'studyEndDate'], educationModified)
  }

  return modifications
}
